import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RiTakeawayLine } from 'react-icons/ri';
import { AiFillCheckCircle } from 'react-icons/ai';
import { FiShoppingBag } from 'react-icons/fi';

import {
  saveTakeawayEnabled,
  saveDeliveryEnabled,
} from '../../../Store/Modules/Store/Actions';
import { Container, StyledCard } from './styles';

function DeliveryType() {
  const dispatch = useDispatch();

  const { deliveryEnabled, takeawayEnabled } = useSelector(
    (state) => state.store,
  );

  function handleChangeDelivery() {
    dispatch(saveDeliveryEnabled(!deliveryEnabled));
  }

  function handleChangeTakeaway() {
    dispatch(saveTakeawayEnabled(!takeawayEnabled));
  }

  return (
    <Container>
      <StyledCard onClick={handleChangeDelivery} active={deliveryEnabled}>
        <span class='badge'>
          <AiFillCheckCircle style={{ color: 'orange', fontSize: '20px' }} />
        </span>
        <span class='icon'>
          <RiTakeawayLine style={{ fontSize: '30px' }} />
        </span>
        <span class='text'>Entrega</span>
      </StyledCard>
      <StyledCard onClick={handleChangeTakeaway} active={takeawayEnabled}>
        <span class='badge'>
          <AiFillCheckCircle style={{ color: 'orange', fontSize: '20px' }} />
        </span>
        <span class='icon'>
          <FiShoppingBag style={{ fontSize: '30px' }} />
        </span>
        <span class='text'>Retirada</span>
      </StyledCard>
    </Container>
  );
}

export default DeliveryType;
